import React from 'react';
import styled from "styled-components";
import { Table } from "antd";
import COLORS from "../../Common/Colors";

const StyledTable = styled(Table)`
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    .ant-scrollbars-hide-scrollbar & {
      overflow: hidden;
    }
    .ant-scrollbars-hide-scrollbar &::-webkit-scrollbar {
      display: none;
    }
  }
  .ant-table-tbody > tr > td {
    border: none;
    font-size: 12px;
  }
  .ant-table-cell {
    padding: 5px 0px;
    height: 0px !important;
  }
  .ant-table-thead .ant-table-cell {
    background-color: #E2E2E8;
    color: #636980;
    font-weight: 600;
    border:none;
    font-size: 14px;
  }
  .non-white {
    background: #F9F9F9;
  }
  .normal-column {
    white-space: normal;
  }
  .ant-table-tbody > tr {
    transition: box-shadow 0.3s ease, transform 0.3s ease;
    color: #636980;
  }
  .ant-table-tbody > tr:hover > td {
    background-color: ${COLORS.hoverBackground || '#F0F0F0'}; /* Default hover color or from COLORS */
    cursor: pointer;
  }
  .ant-table-tbody > tr:hover{
    box-shadow: 0px 3px 6px #00000029;
    color: #000;
  }
`;

const UITable = ({data, columns, name, rowSelection}) => {

    const scrollY = data.length > 3 ? 80 : undefined;
    const shiftscrollY = data.length > 6 ? 150 : undefined;

    const scroll = name !== "Shift" ? scrollY : shiftscrollY;

  return (<>
    {data.length > 0 ?
    <StyledTable dataSource={data} columns={columns} pagination={false} scroll={{ y: scroll }} rowSelection={rowSelection} />
    : 
    <div className='text-center mt-5 pt-4'>No Data</div>}
    </>
  );
};

export default UITable;
